/* jshint esversion: 6 */
/* jshint ignore:start */
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
// import AppleIcon from "../assets/Image/AppLogo.png";
import PlaystoreIcon from "../assets/Image/Playstore.png";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../assets/Image/Logo.png";
import { LuHeart } from "react-icons/lu";

const Footer = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, setActivePage } = useContext(MyContext);
  
  const [pageList, setPageList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .post(`${ApiBaseUrl}/customer/pages`)
      .then((res) => {
        setPageList(res.data.pages_data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const HandleNavigate = (path, id) => {
    setActivePage(id);
    navigate(`/${path}`, { state: true });
  };

  const HandleOpenLink = (link) => {
    window.open(link, "_blank");
  };

  const socials = [
    { Icon: FaFacebookF, label: "Facebook", color: "hover:bg-blue-600" },
    { Icon: FaTwitter, label: "Twitter", color: "hover:bg-sky-500" },
    { Icon: FaInstagram, label: "Instagram", color: "hover:bg-pink-600" },
    { Icon: FaYoutube, label: "YouTube", color: "hover:bg-red-600" },
  ];

  return (
    <footer>
      {/* Main dark footer */}
      <div className="bg-slate-900 px-4 sm:px-6 lg:px-8 pt-14 pb-8 relative overflow-hidden">
        {/* Decorative gradient blobs */}
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-indigo-600/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-violet-600/10 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-7xl mx-auto relative z-10">
          {/* Top grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
            {/* Brand */}
            <div className="sm:col-span-2 lg:col-span-2">
              <Link
                to="/"
                className="inline-flex items-center gap-3 group mb-5"
              >
                <div className="w-11 h-11 rounded-2xl overflow-hidden border border-white/10 shadow-lg shrink-0">
                  <img
                    src={Logo}
                    className="w-full h-full object-cover"
                    alt="Doctorrhynor logo"
                  />
                </div>
                <span className="font-bold text-2xl text-white group-hover:text-indigo-400 transition-colors duration-200">
                  Doctorrhynor
                </span>
              </Link>

              <p className="text-slate-400 text-sm font-medium leading-relaxed max-w-sm">
                {t(
                  "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,",
                )}{" "}
                {t("managing, and attending doctor's appointments.")}
              </p>

              {/* Socials */}
              <div className="flex items-center gap-2.5 mt-6">
                {socials.map(({ Icon, label, color }, idx) => (
                  <button
                    key={idx}
                    aria-label={label}
                    className={`w-9 h-9 rounded-xl bg-white/10 border border-white/10 text-slate-400 hover:text-white ${color} flex items-center justify-center transition-all duration-200 active:scale-90`}
                  >
                    <Icon className="text-[15px]" />
                  </button>
                ))}
              </div>
            </div>

            {/* Pages */}
            {pageList.length > 0 && (
              <div className="flex flex-col gap-2">
                <span className="text-indigo-400 text-[11px] font-black uppercase tracking-widest mb-3">
                  {t("Pages")}
                </span>
                {pageList.map((item, index) => {
                  const FinalText = item.title
                    .replace(/\s+/g, "_")
                    .toLowerCase();
                  return (
                    <button
                      key={index}
                      onClick={() => HandleNavigate(FinalText, index + 8)}
                      className="text-left text-slate-400 hover:text-white font-semibold text-sm transition-colors duration-150 leading-relaxed"
                    >
                      {item.title}
                    </button>
                  );
                })}
              </div>
            )}

            {/* Download */}
            <div className="flex flex-col gap-3">
              <span className="text-indigo-400 text-[11px] font-black uppercase tracking-widest mb-1">
                {t("Download App")}
              </span>

              {/* iOS App Store link (commented out) */}
              {/* <div className="flex flex-col gap-1">
                <span className="text-slate-400 text-xs font-semibold">
                  {t("iOS App")}
                </span>
                <button
                  onClick={() =>
                    HandleOpenLink(
                      "https://apk.cscodetech.cloud/GoDoctorCustomerApp.apk",
                    )
                  }
                  className="hover:opacity-80 active:scale-95 transition-all duration-150 w-fit"
                >
                  <img
                    src={AppleIcon}
                    className="w-36 rounded-xl"
                    alt="App Store"
                  />
                </button>
              </div> */}

              {/* User App */}
              <div className="flex flex-col gap-1">
                <span className="text-slate-400 text-xs font-semibold">
                  {t("User App")}
                </span>
                <button
                  onClick={() =>
                    HandleOpenLink(
                      "https://doctorrhynor.com/doctorrhynorcustomer.apk",
                    )
                  }
                  className="hover:opacity-80 active:scale-95 transition-all duration-150 w-fit"
                >
                  <img
                    src={PlaystoreIcon}
                    className="w-36 rounded-xl"
                    alt="Play Store User App"
                  />
                </button>
              </div>

              {/* Doctor App */}
              <div className="flex flex-col gap-1">
                <span className="text-slate-400 text-xs font-semibold">
                  {t("Doctor App")}
                </span>
                <button
                  onClick={() =>
                    HandleOpenLink(
                      "https://doctorrhynor.com/doctorrhynordoctor.apk",
                    )
                  }
                  className="hover:opacity-80 active:scale-95 transition-all duration-150 w-fit"
                >
                  <img
                    src={PlaystoreIcon}
                    className="w-36 rounded-xl"
                    alt="Play Store Doctor App"
                  />
                </button>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-slate-500 text-xs font-semibold text-center sm:text-left">
              © {new Date().getFullYear()} Doctorrhynor.{" "}
              {t("@ Powered By Doctorrhynor")}
            </p>
            <p className="text-slate-500 text-xs font-medium flex items-center gap-1">
              Made with <LuHeart className="text-rose-500 w-3.5 h-3.5" /> by
              CsCodeTech Team
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
/* jshint ignore:end */
